import { create } from 'zustand';
import { persist, createJSONStorage, StateStorage, devtools } from 'zustand/middleware';
import { UserStateStore } from './types';
import safestorage from '@libs/utils/helpers/getSafeStorage';
import { initialState } from './initialState';

export const useUserStore = create<UserStateStore>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        addScore: (payload) => set({ score: { ...get().score, ...payload } }),
        addSortingDebt: (payload) => set({ sortingDebt: { ...get().sortingDebt, ...payload } }),
        addMyDebt: (payload) => set({ myDebt: { ...get().myDebt, ...payload } }),
        addSimulatedDebts: (payload) => set({ simulatedDebts: payload }),
        resetSimulatedDebts: () => set({ simulatedDebts: initialState.simulatedDebts }),
        resetStore: () => {
          useUserStore.persist.clearStorage();
          set(initialState);
        },
      }),
      {
        name: 'ac-data-store',
        storage: createJSONStorage(() => safestorage as StateStorage),
        partialize: (state) => {
          const scoreData = state?.score;
          if (scoreData) {
            const { negativeDebts: _, ...score } = scoreData;
            return { ...state, score };
          }
          return state;
        },
        migrate: (persistedState, _version) => {
          // one-shot: limpar chaves legadas do localStorage
          if (typeof window !== 'undefined') {
            localStorage.removeItem('ac/ac-user-store');
            localStorage.removeItem('ac/AUTH_USER_DATA');
            localStorage.removeItem('ac/AUTH_USER_TOKEN');
          }
          return persistedState;
        },
        version: 1,
      }
    )
  )
);
